import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import {
  openModal,
  ImageToUpload,
  thumbnailImageUpload,
  uploadNewImage,
  addImageToGallery,
  uploadGalleryImage,
  uploadImagesServerSide,
} from "GalleryActions";
import { showError, showSuccess } from "ReduxErrorBar";
import Dropzone from "react-dropzone";
import { randomstring } from "randomstring-js";
import ProcessImage from "react-imgpro";
import { NEW_IMAGE_PATH, COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";

class AddImages extends Component {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.setEditorRef = this.setEditorRef.bind(this);
    this.state = {
      loading: false,
      isProcessing: false,
      height: 0,
      width: 0,
      uploadedFiles: [],
      original_image_data: [],
      fiesnNameArray: [],
    };
  }

  setEditorRef = (editor) => (this.editor = editor);

  open() {
    this.props.openModal({ showModal: true });
  }

  close() {
    this.props.openModal({ showModal: false });
    this.setState({
      original_image_data: [],
      loading: false,
      isProcessing: false,
    });
    //this.props.ImageToUpload({});
    //this.props.thumbnailImageUpload({});
  }

  onDrop(files) {
    // let file = files[0];

    if (files.length <= 10) {
      let filesArray = [];
      files.forEach((file) => {
        let reader = new FileReader();
        if (file && file.type.indexOf("image") !== -1) {
          //Determine if it is a valid file...
          var uploadedimage = new Image();
          uploadedimage.addEventListener("load", () => {
            reader.onloadend = () => {
              var width = uploadedimage.width;
              var height = uploadedimage.height;
              if (width > 1500) {
                width = 1500;
              }
              var imageData = { imagefile: reader.result, width: width };
              filesArray.push(imageData);
            };
            reader.readAsDataURL(file);
          });
          uploadedimage.src = window.URL.createObjectURL(file);
        } else {
        }
      });
      setTimeout(() => {
        this.setState({
          original_image_data: filesArray,
          uploadedFiles: files,
        });
      }, 300);
    } else {
      this.props.showError("Only 10 images are allowed to upload at a time");
    }
  }

  processUpload = () => {
    let { original_image_data, uploadedFiles } = this.state;

    this.setState({ loading: true });
    this.props.uploadImagesServerSide(
      this.props.session,
      original_image_data,
      (response) => {
        if (response.success) {
          let message =
            response.response.total_request_image_to_upload ==
            response.response.total_image_uploaded
              ? "All images uploaded successfully!"
              : `${response.response.total_image_uploaded} uploaded out of ${response.response.total_request_image_to_upload}`;

          this.props.showSuccess(message);
          this.props.callContentBoardStatus();
          this.setState({ loading: false });
          this.close();
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
          this.setState({ loading: false });
        }
      }
    );
  };

  renderImageProcess = () => {
    let { original_image_data, fiesnNameArray } = this.state;

    var item = _.map(original_image_data, (element, index) => {
      var file = fiesnNameArray[index].originalfilename;

      return (
        <ProcessImage
          key={`key_${index}`}
          image={element.imagefile}
          resize={{ width: element.width }}
          quality={70}
          processedImage={this.onImageProcessing.bind(this, file)}
        />
      );
    });

    // this.setState({getoriginal:false,getthumb:true});
    return item;
  };

  onImageProcessing = (filename, src, err) => {
    // var filename=this.state.originalfilename;

    this.props.uploadGalleryImage(
      src,
      filename,
      this.props.session,
      (response) => {
        if (response === "failed") {
          this.props.showError(COMMON_FAIL_MESSAGE);
          this.setState({ loading: false });
          this.setState({});
        } else {
          //   this.setState({getoriginal:false,getthumb:true});
        }
      }
    );
  };

  renderThumbImageProcess = () => {
    let { original_image_data, fiesnNameArray } = this.state;

    var item = _.map(original_image_data, (element, index) => {
      var file = fiesnNameArray[index];

      return (
        <ProcessImage
          key={`key_thumb_${index}`}
          image={element.imagefile}
          resize={{ width: 450 }}
          quality={60}
          processedImage={this.onThumbImageProcessing.bind(this, file)}
        />
      );
    });
    // this.setState({getoriginal:false,getthumb:false});
    return item;
  };

  onThumbImageProcessing = (file, src, err) => {
    var filename = file.thumbfilename;

    this.props.uploadGalleryImage(
      src,
      filename,
      this.props.session,
      (response) => {
        if (response === "failed") {
          this.props.showError(COMMON_FAIL_MESSAGE);
          this.setState({ loading: false });
        } else {
          // this.setState({getoriginal:false,getthumb:false});
          //   var data={originalfilename:this.state.originalfilename,thumbfilename:this.state.thumbfilename};
          var data = {
            originalfilename: file.originalfilename,
            thumbfilename: file.thumbfilename,
          };

          this.props.addImageToGallery(data, this.props.session, (response) => {
            if (response.success === 1) {
              this.props.showSuccess("Image uploaded successfully!");
              this.setState({ loading: false });
              this.close();
            } else {
              this.props.showError(COMMON_FAIL_MESSAGE);
              this.setState({ loading: false });
            }
          });
        }
      }
    );
  };

  render() {
    let { original_image_data, loading } = this.state;

    let disabled = true;
    if (_.size(original_image_data) > 0) {
      disabled = false;
    }

    if (loading) {
      disabled = true;
    }

    var overlayStyle = {
      width: "100%",
      height: "85%",
      padding: "2.5em 0",
      textAlign: "center",
      border: "1px dashed #2676ea",
      background: "white",
      borderRadius: 5,
    };

    var overlayStyle1 = {
      width: "100%",
      height: "85%",
      padding: "10px 0px",
      textAlign: "center",
      border: "1px dashed #2676ea",
      background: "white",
      borderRadius: 5,
      marginTop: 30,
      display: "flex",
      minHeight: 300,
    };

    var mapImage = {
      // height:'350px',
      width: "100%",
      objectFit: "contain",
    };

    var moreThanTroImages = {
      opacity: 0.3,
      display: "block",
      width: "100%",
      transition: ".5s ease",
      backfaceVisibility: "hidden",
    };

    var dropzoneText = <div>{LocaleStrings.gallery_dropzonetext}</div>;

    let btnDisable = true;
    return (
      <div>
        <Button
          className="btn-custom-blue schedule-add-button"
          bsStyle=""
          onClick={this.open.bind(this)}
        >
          {/* <i className="fa fa-plus i-custom-m" aria-hidden="true"/> Upload Image */}
          <img
            style={{ paddingRight: 8, paddingBottom: 3 }}
            src="../../style/images/header-icons/plus.png"
          ></img>
          {LocaleStrings.upload_image}
        </Button>
        <div>
          <Modal
            className="modal-container"
            show={this.props.showModal.showModal === true ? true : false}
            onHide={this.close}
            animation={true}
            keyboard={false}
            backdrop="static"
            size="lg"
          >
            <Modal.Header>
              <div className="import-modal-title">
                {LocaleStrings.gallery_uploadimage}
              </div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={() => this.close()}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-md-12">
                  {original_image_data && original_image_data.length > 0 ? (
                    original_image_data.length == "1" ? (
                      <div style={overlayStyle1}>
                        <img
                          style={mapImage}
                          src={original_image_data[0].imagefile}
                        />
                      </div>
                    ) : original_image_data.length == 2 ? (
                      <div style={overlayStyle1}>
                        <div
                          style={{
                            width: "50%",
                            padding: 5,
                            borderRight: "1px dashed black",
                          }}
                        >
                          <img
                            style={mapImage}
                            src={original_image_data[0].imagefile}
                          />
                        </div>
                        <div style={{ width: "50%", padding: 5 }}>
                          <img
                            style={mapImage}
                            src={original_image_data[1].imagefile}
                          />
                        </div>
                      </div>
                    ) : (
                      <div style={overlayStyle1}>
                        <div
                          style={{
                            width: "50%",
                            padding: 5,
                            borderRight: "1px dashed black",
                          }}
                        >
                          <img
                            style={mapImage}
                            src={original_image_data[0].imagefile}
                          />
                        </div>
                        <div
                          style={{
                            width: "50%",
                            padding: 5,
                            backgroundColor: "#71757961",
                          }}
                        >
                          <img
                            style={moreThanTroImages}
                            src={original_image_data[1].imagefile}
                          />
                          <div className="overlay-div" style={{ fontSize: 50 }}>
                            + {original_image_data.length - 2}
                          </div>
                        </div>
                      </div>
                    )
                  ) : (
                    <div className="dropzone p-0">
                      <Dropzone
                        accept="image/jpeg, image/png"
                        onDrop={this.onDrop.bind(this)}
                        multiple={true}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <div style={overlayStyle}>
                            <div
                              style={{ paddingTop: 130, paddingBottom: 130 }}
                              {...getRootProps()}
                              className="drop-text"
                            >
                              <div>
                                <img src={`${NEW_IMAGE_PATH}picture.png`} />
                              </div>
                              <div style={{ color: "#a2a3b1" }}>
                                {dropzoneText}
                              </div>
                              <input {...getInputProps()} />
                            </div>
                          </div>
                        )}
                      </Dropzone>
                    </div>
                  )}
                  <div style={{ display: "none" }}>
                    {this.state.getoriginal ? this.renderImageProcess() : null}
                  </div>

                  <div style={{ display: "none" }}>
                    {this.state.getthumb
                      ? this.renderThumbImageProcess()
                      : null}
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                onClick={() => this.close()}
                className="btn btn-custom-white"
                type="button"
              >
                Close
              </button>
              <Button
                bsStyle=""
                className="btn btn-custom-blue ml-10"
                type="button"
                loading={this.state.loading}
                onClick={this.processUpload}
                disabled={loading || disabled}
              >
                Save Changes
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showModal: state.galleryModal,
    /*,
        imageReadyToAddGallery: state.imageReadyToAddGallery,
        thumbnailImage: state.thumbnailImage,*/
  };
}

export default connect(mapStateToProps, {
  uploadNewImage,
  uploadGalleryImage,
  addImageToGallery,
  openModal,
  showError,
  showSuccess,
  uploadImagesServerSide,
})(AddImages);
